import { apiFetch } from './client';
import type {
  DashboardSummary,
  Paginated,
  RequestLogDetail,
  RequestLogListItem,
} from './types';

export interface ListRequestsParams {
  page?: number;
  pageSize?: number;
  status?: string;
  vertical?: string;
  project?: string;
}

export const getDashboard = () => apiFetch<DashboardSummary>('/dashboard');

export const listRequests = (params: ListRequestsParams = {}) => {
  const qs = new URLSearchParams();
  if (params.page) qs.set('page', String(params.page));
  if (params.pageSize) qs.set('pageSize', String(params.pageSize));
  if (params.status) qs.set('status', params.status);
  if (params.vertical) qs.set('vertical', params.vertical);
  if (params.project) qs.set('project', params.project);
  const q = qs.toString();
  return apiFetch<Paginated<RequestLogListItem>>(
    `/audit/requests${q ? `?${q}` : ''}`,
  );
};

export const getRequest = (id: string) =>
  apiFetch<RequestLogDetail>(`/audit/requests/${id}`);

export const listApprovals = (status?: string, page = 1, pageSize = 25) => {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  if (status && status !== 'all') params.set('status', status);
  return apiFetch<import('./types').ApprovalsList>(`/audit/approvals?${params.toString()}`);
};

export const reviewAllRequests = (decision: 'acknowledged' | 'dismissed') =>
  apiFetch<{ count: number; decision: string }>('/audit/requests/review-all', {
    method: 'POST',
    body: JSON.stringify({ decision }),
  });

export const listEvidence = (page = 1, pageSize = 50) =>
  apiFetch<import('./types').EvidenceList>(`/audit/evidence?page=${page}&pageSize=${pageSize}`);
